/*
  mayie-pdp2-final.js: săgețile șinei de clipuri (sections/mayie-pdp2-final-clips.liquid, șablonul product.info-final), doar pe ecranele cu mouse.
  Doar click, fără ascultători de derulare; redarea o face <deferred-media> din Dawn (global.js).
*/
(function () {
  function init(root) {
    var list = root.querySelector('[data-pdp2f-list]');
    if (!list) return;
    root.querySelectorAll('[data-pdp2f-dir]').forEach(function (btn) {
      if (btn.dataset.pdp2fBound) return;
      btn.dataset.pdp2fBound = '1';
      btn.addEventListener('click', function () {
        var item = list.querySelector('li');
        var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        var step = item ? item.getBoundingClientRect().width + gap : list.clientWidth * 0.8;
        var count = Math.max(1, Math.floor(list.clientWidth / step));
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollBy({ left: Number(btn.dataset.pdp2fDir) * step * count, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }
  document.querySelectorAll('[data-pdp2f-rail]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-pdp2f-rail]').forEach(init);
  });
})();
